import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Inicio',
    meta: {
      title: 'zidarspace | inicio',
      metaTags: [
       
        {
          name: 'description',
          content: 'Profesionales en diseño de espacios arquitectónicos, construcción, gestión de obras y asesoramiento.'
        },
        {
          property: 'og:description',
          content: 'Profesionales en diseño de espacios arquitectónicos, construcción, gestión de obras y asesoramiento.'
        }
      ],
    },
    component: () => import(/* webpackChunkName: "home" */ '../views/Inicio.vue'),
   
  },
  {
    path: '/servicios',
    name: 'Servicios',
    meta: {
      title: 'zidarspace | servicios',
      metaTags: [
        {
          name: 'description',
          content: 'Somos un equipo de profesionales con mas de 40 años de experiencia y dedicación en diseño de espacios arquitectónicos.'
        },
        {
          property: 'og:description',
          content: 'Somos un equipo de profesionales con mas de 40 años de experiencia y dedicación en diseño de espacios arquitectónicos.'
        }
      ],
    },

    component: () => import(/* webpackChunkName: "servicios" */ '../views/Servicios.vue')
  },
  {
    path: '/obras',
    name: 'Obras',
    title:'Obras',
    meta: {
      title: 'zidarspace | obras',
      metaTags: [
        {
          name: 'description',
          content: 'Más de 40 años en el rublo de la construcción. Diseño, proyecto y construcción responsable.'
        },
        {
          property: 'og:description',
          content: 'Más de 40 años en el rublo de la construcción. Diseño, proyecto y construcción responsable.'
        }
      ],
    },
   
    component: () => import(/* webpackChunkName: "obras" */ '../views/Obras.vue')
  },
  {
    path: '/contacto',
    name: 'Contacto',
    meta: {
      title: 'zidarspace | contacto',
      metaTags: [
        {
          name: 'description',
          content: 'Asesoramos a nuestros clientes con responsabilidad y seriedad, brindando garantía de nuestros trabajos.'
        },
        {
          property: 'og:description',
          content: 'Asesoramos a nuestros clientes con responsabilidad y seriedad, brindando garantía de nuestros trabajos.'
        }
      ],
    },

    component: () => import(/* webpackChunkName: "contacto" */ '../views/Contacto.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name:'Not-Found',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ...

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

// ...

export default router
